import React from "react";
import get from "lodash/get";
import noop from "lodash/noop";
import classNames from "classnames";
import PropTypes from "prop-types";

import {ErrorDisplay} from "shared/General/components/ErrorDisplay/ErrorDisplay";

import {InboxEmpty} from "../InboxEmpty/InboxEmpty";
import InboxItem from "../InboxItem/InboxItem";
import s from "./InboxUI.pcss";

const InboxUILegacy = (props) => {
    const chatGroups = props.chatGroups.map((chatGroup) => (
        <InboxItem
            key={chatGroup.id}
            id={chatGroup.id}
            dataTestId={"inbox-item-id"}
            creationSource={chatGroup.creationSource}
            message={chatGroup.lastMessage}
            unread={chatGroup.unreadMessageCount}
            user={chatGroup.opponent}
            onClick={() => {
                props.onOpenChat(chatGroup.id);
            }}
            showOnlineStatus={props.showOnlineStatus}
            university={props.university}
            isExternal={props.isExternal}
        />
    ));
    const universityChatGroup = props.universityChatGroup ? (
        <InboxItem
            key="university-chat"
            id={get(props, "universityChatGroup.id")}
            message={get(props.universityChatGroup, "message")}
            unread={get(props.universityChatGroup, "unreadMessageCount", 0)}
            user={get(props, "universityChatGroup.user")}
            onClick={() => props.onOpenUniversityChat(get(props, "universityChatGroup.id"))}
            showOnlineStatus={props.showOnlineStatus}
        />
    ) : null;

    const chatGroupsExist = props.chatGroups.length !== 0 || props.universityChatGroup;
    return (
        <ErrorDisplay error={props.error}>
            <div className={classNames(s.container, props.className)}>
                {!props.loading && !chatGroupsExist ? <InboxEmpty /> : null}
                {universityChatGroup}
                {chatGroups}
            </div>
        </ErrorDisplay>
    );
};

InboxUILegacy.propTypes = {
    loading: PropTypes.bool,
    chatGroups: PropTypes.array.isRequired,
    universityChatGroup: PropTypes.shape({
        message: PropTypes.object.isRequired,
        unreadMessageCount: PropTypes.object.isRequired,
        user: PropTypes.shape({
            firstName: PropTypes.string.isRequired,
            profilePhoto: PropTypes.string.isRequired,
        }).isRequired,
    }),
    showOnlineStatus: PropTypes.bool,
    // eslint-disable-next-line react/no-unused-prop-types
    onOpenChat: PropTypes.func.isRequired,
    onOpenUniversityChat: PropTypes.func,
    university: PropTypes.object,
    isExternal: PropTypes.bool,
    error: PropTypes.object,
};

InboxUILegacy.defaultProps = {
    loading: false,
    showOnlineStatus: true,
    universityChatGroup: null,
    onOpenUniversityChat: noop,
    university: {},
    isExternal: false,
    error: null,
};

export default InboxUILegacy;
